import { render, staticRenderFns } from "./Vpn.vue?vue&type=template&id=052fa6f9&"
import script from "./Vpn.vue?vue&type=script&lang=js&"
export * from "./Vpn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports